var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMacchineInFila(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 474.25,
    height: 49.837,
    viewBox: "0 0 474.25 49.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1011",
    "data-name": "Raggruppa 1011",
    transform: "translate(36.875 -184.825)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1010",
    "data-name": "Raggruppa 1010",
    transform: "translate(200.296 -197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Coup\\xE8",
    transform: "translate(-132.775 397.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_110",
    "data-name": "Raggruppa 110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_266",
    "data-name": "Tracciato 266",
    d: "M76.6,76.8H12.935a1.626,1.626,0,0,1-1.625-1.625V68.926a7.529,7.529,0,0,1,2.2-5.317l7.132-10.3a5.16,5.16,0,0,1,4.248-2.225H38.149a15.122,15.122,0,0,1,8.114,2.367l15.464,9.875h5.24a11.292,11.292,0,0,1,11.26,11.26v.583A1.627,1.627,0,0,1,76.6,76.8Z",
    transform: "translate(-11.31 -51.085)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_68",
    "data-name": "Ellisse 68",
    cx: 6.522,
    cy: 6.522,
    r: 6.522,
    transform: "translate(7.454 19.761)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_69",
    "data-name": "Ellisse 69",
    cx: 6.522,
    cy: 6.522,
    r: 6.522,
    transform: "translate(46.562 19.761)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_267",
    "data-name": "Tracciato 267",
    d: "M30.034,51.08V63.327H15.84",
    transform: "translate(-13.37 -51.08)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_268",
    "data-name": "Tracciato 268",
    d: "M52.5,51.08V63.327H83.123",
    transform: "translate(-30.04 -51.08)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_226",
    "data-name": "Linea 226",
    x2: 5.497,
    transform: "translate(23.524 17.417)",
    fill: "none",
    stroke: "#dd2027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Furgoni_VAN",
    "data-name": "Furgoni VAN",
    transform: "translate(-235.921 383.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_111",
    "data-name": "Raggruppa 111"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linea_227",
    "data-name": "Linea 227",
    x1: 6.069,
    transform: "translate(1.543 19.276)",
    fill: "none",
    stroke: "#dd2027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_269",
    "data-name": "Tracciato 269",
    d: "M77.094,64.8H12.614a1.673,1.673,0,0,1-1.674-1.685l.245-34.059a4.64,4.64,0,0,1,4.64-4.608H60.452a9.236,9.236,0,0,1,6.62,2.8l9.052,9.319A9.235,9.235,0,0,1,78.73,42.99V63.171A1.64,1.64,0,0,1,77.094,64.8Z",
    transform: "translate(-10.94 -24.445)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_70",
    "data-name": "Ellisse 70",
    cx: 6.407,
    cy: 6.407,
    r: 6.407,
    transform: "translate(9.461 34.522)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_71",
    "data-name": "Ellisse 71",
    cx: 6.407,
    cy: 6.407,
    r: 6.407,
    transform: "translate(43.181 34.522)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_270",
    "data-name": "Tracciato 270",
    d: "M92.02,24.44v14.8A4.482,4.482,0,0,0,96.5,43.721h19.1",
    transform: "translate(-47.808 -24.44)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_228",
    "data-name": "Linea 228",
    x2: 5.524,
    transform: "translate(31.06 24.8)",
    fill: "none",
    stroke: "#dd2027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Monovolume",
    transform: "translate(-30.501 388.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_112",
    "data-name": "Raggruppa 112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_271",
    "data-name": "Tracciato 271",
    d: "M76.953,69.443H16.889a1.558,1.558,0,0,1-1.56-1.57l.229-29.691a4.32,4.32,0,0,1,4.324-4.291H61.451A8.57,8.57,0,0,1,67.612,36.5l8.43,8.681a8.6,8.6,0,0,1,2.427,5.982V67.921A1.521,1.521,0,0,1,76.953,69.443Z",
    transform: "translate(-15.33 -33.885)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_72",
    "data-name": "Ellisse 72",
    cx: 6.609,
    cy: 6.609,
    r: 6.609,
    transform: "translate(6.647 28.971)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_73",
    "data-name": "Ellisse 73",
    cx: 6.609,
    cy: 6.609,
    r: 6.609,
    transform: "translate(41.18 28.971)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_272",
    "data-name": "Tracciato 272",
    d: "M90.85,33.88V51.836h21.959",
    transform: "translate(-49.67 -33.88)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_229",
    "data-name": "Linea 229",
    x2: 5.148,
    transform: "translate(28.933 23.104)",
    fill: "none",
    stroke: "#dd2027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_230",
    "data-name": "Linea 230",
    y2: 4.133,
    transform: "translate(12.902 12.193)",
    fill: "none",
    stroke: "#dd2027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_231",
    "data-name": "Linea 231",
    y2: 4.133,
    transform: "translate(28.459 12.193)",
    fill: "none",
    stroke: "#dd2027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_232",
    "data-name": "Linea 232",
    x2: 41.044,
    transform: "translate(0.136 17.956)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Station_wagon",
    "data-name": "Station wagon",
    transform: "translate(67.994 393.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_113",
    "data-name": "Raggruppa 113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_273",
    "data-name": "Tracciato 273",
    d: "M77.285,73.2H10.034A1.614,1.614,0,0,1,8.42,71.589V58.022a6.314,6.314,0,0,1,1.085-3.544l6.451-9.57A4.853,4.853,0,0,1,19.98,42.77H51.416L63.958,54.957h5.867A9.1,9.1,0,0,1,78.9,64.036v7.558A1.621,1.621,0,0,1,77.285,73.2Z",
    transform: "translate(-8.42 -42.77)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_74",
    "data-name": "Ellisse 74",
    cx: 6.342,
    cy: 6.342,
    r: 6.342,
    transform: "translate(10.524 24.658)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_75",
    "data-name": "Ellisse 75",
    cx: 6.342,
    cy: 6.342,
    r: 6.342,
    transform: "translate(50.652 24.658)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_274",
    "data-name": "Tracciato 274",
    d: "M72.3,42.77V54.952H94.226",
    transform: "translate(-37.467 -42.77)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_233",
    "data-name": "Linea 233",
    x2: 5.464,
    transform: "translate(36.327 19.14)",
    fill: "none",
    stroke: "#dd2027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_234",
    "data-name": "Linea 234",
    x2: 5.469,
    transform: "translate(23.207 19.14)",
    fill: "none",
    stroke: "#dd2027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_235",
    "data-name": "Linea 235",
    y2: 4.39,
    transform: "translate(18.578 7.023)",
    fill: "none",
    stroke: "#dd2027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_275",
    "data-name": "Tracciato 275",
    d: "M39.007,42.77V54.952H11.23",
    transform: "translate(-9.698 -42.77)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fuoristrada_-_Pick_Up",
    "data-name": "Fuoristrada - Pick Up",
    transform: "translate(166.261 391.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_114",
    "data-name": "Raggruppa 114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_276",
    "data-name": "Tracciato 276",
    d: "M12.623,67.589H9.531A2.248,2.248,0,0,1,7.29,65.348V55.211A2.248,2.248,0,0,1,9.531,52.97h3.1a2.248,2.248,0,0,1,2.241,2.241V65.348A2.256,2.256,0,0,1,12.623,67.589Z",
    transform: "translate(-7.29 -45.505)",
    fill: "#dd2027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_277",
    "data-name": "Tracciato 277",
    d: "M82.236,68.633H24.125a1.565,1.565,0,0,1-1.565-1.565V40.883a1.606,1.606,0,0,1,1.6-1.6H59.411a1.6,1.6,0,0,1,1.216.562l11.686,13.73h9.93a1.559,1.559,0,0,1,1.56,1.56V67.068A1.565,1.565,0,0,1,82.236,68.633Z",
    transform: "translate(-14.233 -39.28)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_76",
    "data-name": "Ellisse 76",
    cx: 6.151,
    cy: 6.151,
    r: 6.151,
    transform: "translate(15.628 26.392)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_77",
    "data-name": "Ellisse 77",
    cx: 6.151,
    cy: 6.151,
    r: 6.151,
    transform: "translate(50.483 26.392)",
    fill: "#fff",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_278",
    "data-name": "Tracciato 278",
    d: "M77.08,39.28v14.3H96.356",
    transform: "translate(-39.024 -39.28)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_236",
    "data-name": "Linea 236",
    x2: 4.128,
    transform: "translate(40.88 19.996)",
    fill: "none",
    stroke: "#dd2027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_237",
    "data-name": "Linea 237",
    x2: 4.128,
    transform: "translate(26.55 19.996)",
    fill: "none",
    stroke: "#dd2027",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_238",
    "data-name": "Linea 238",
    x1: 29.729,
    transform: "translate(8.327 14.297)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacchineInFila);
export default __webpack_public_path__ + "static/media/macchine-in-fila.3b0574a990c3f9196628a65e486f88e2.svg";
export { ForwardRef as ReactComponent };